import { getLocalePath } from '@dashboard/junk-drawer/utils/i18n-link';
export default function sqHelpLink({
  articleId,
  articleSection,
  utmParams = {
    utmSource: 'dashboard',
    utmMedium: 'web'
  },
  userInfo
}) {
  const localePath = getLocalePath(userInfo?.countryCode ?? '', userInfo?.languageCode ?? '');
  let url = `//squareup.com/help/${localePath}article/${articleId}`;
  const params = [];
  if (utmParams?.utmContent) {
    params.push(`utm_content=${utmParams.utmContent}`);
  }
  if (utmParams?.utmSource) {
    params.push(`utm_source=${utmParams.utmSource}`);
  }
  if (utmParams?.utmMedium) {
    params.push(`utm_medium=${utmParams.utmMedium}`);
  }
  if (utmParams?.utmCampaign) {
    params.push(`utm_campaign=${utmParams.utmCampaign}`);
  }
  if (params.length > 0) {
    url += `?${params.join('&')}`;
  }
  if (articleSection) {
    url += `#${articleSection}`;
  }
  return url;
}